module.exports = __webpack_public_path__ + "img/editora-caras.e0d56e93.svg";